import { useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import SubNav from "Components/Navbar/SubNav/SubNav";

interface Crumb {
  label: string;
  link?: string;
  onClick?: () => void;
}

export interface GcOutletContext {
  setCrumbs: (crumbs: Crumb[]) => void;
}

export function useGcLayout() {
  return useOutletContext<GcOutletContext>();
}

export default function GcLayout() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const firstName: string = user?.firstName ?? "";
  const lastName: string = user?.lastName ?? "";
  const userName = `${firstName} ${lastName}`.trim() || "GC User";
  const userInitials =
    `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase() || "GC";

  const [crumbs, setCrumbs] = useState<Crumb[]>([]);

  return (
    <>
      <SubNav
        crumbs={crumbs}
        userName={userName}
        userInitials={userInitials}
        role="General Contractor"
        crumbClass="crumbs"
        showSignout
        notifications={true}
      />
      <Outlet context={{ setCrumbs } satisfies GcOutletContext} />
    </>
  );
}
